import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import Layout from './Layout';
import ProtectedRoute from './ProtectedRoute';
import PageLoader from './PageLoader';

const AuthenticatedLayout = () => (
  <ProtectedRoute>
    <Layout>
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </Layout>
  </ProtectedRoute>
);

export default AuthenticatedLayout;
